// extracted by mini-css-extract-plugin
module.exports = {"actions":"QuickActions_actions__G8Zxh"};